export enum JgInspType {
  PHYSICAL = 'PHYSICAL',
  LOAD = 'LOAD',
  VISUAL = 'VISUAL',
}

export const JgInspTypeListMap = {
  [JgInspType.PHYSICAL]: '实体检测',
  [JgInspType.LOAD]: '荷载实验',
  [JgInspType.VISUAL]: '外观检查',
};

export const JgInspTypeOptions = [
  {
    label: '实体检测',
    value: JgInspType.PHYSICAL,
  },
  {
    label: '荷载实验',
    value: JgInspType.LOAD,
  },
  {
    label: '外观检查',
    value: JgInspType.VISUAL,
  },
];
